import { render, staticRenderFns } from "./TextImageCard.vue?vue&type=template&id=6c6a6176&scoped=true&"
import script from "./TextImageCard.vue?vue&type=script&lang=js&"
export * from "./TextImageCard.vue?vue&type=script&lang=js&"
import style0 from "./TextImageCard.vue?vue&type=style&index=0&id=6c6a6176&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a6176",
  null
  
)

export default component.exports